module.exports = __webpack_public_path__ + "img/workbench_icon5.e314dfb5.svg";